import { useState } from "react";
import { Grid } from "@chakra-ui/react";
import { MotionBox as Box, hoverScaleVariants } from "utils/motion";
import Date from "components/blog/Date";
import Link from "components/base/Link";
import Text from "components/base/Text";
import Image from "components/base/Image";
import Play from "components/icons/Play";

const FeaturedPost = ({ uid, type, data, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const href = type === "episode" ? `/docuseries/${uid}` : `/blog/${uid}`;

  return (
    <Box
      width="100%"
      my={[6, null, 16]}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      {...props}
    >
      <Grid templateColumns={["1fr", null, "1fr 1fr"]}>
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Link href={href}>
            <Box overflow="hidden" bg="black.900" position="relative">
              <Box
                position="absolute"
                bottom={3}
                right={3}
                zIndex={1}
                opacity={type === "episode" ? 1 : 0}
              >
                <Play color="white" />
              </Box>
              <Box
                pt="52.6%"
                position="relative"
                variants={hoverScaleVariants}
                initial="regular"
                animate={isHovered ? "hovered" : "regular"}
              >
                <Image
                  src={data.thumbnail.url}
                  alt={data.thumbnail.alt}
                  style={{ position: "absolute" }}
                  top="0"
                />
              </Box>
            </Box>
          </Link>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          px={[0, null, 6]}
        >
          <Link href={href} _hover={{ textDecoration: "none" }}>
            <Text
              type="headline_md"
              mb={[2, null, 6]}
              color="black.700"
              textTransform="none"
              letterSpacing={0}
            >
              {data.title[0].text}
            </Text>
          </Link>
          <Date date={data.published_date} />
        </Box>
      </Grid>
    </Box>
  );
};

export default FeaturedPost;
